import { Canvas } from 'glsl-canvas-js';
import {wavyLinesFragmentShader} from './shaders/fragment.js';

const options = {
  fragmentString: wavyLinesFragmentShader,
  alpha: false,
  antialias: true,
  mode: 'flat',
  extensions: ['EXT_shader_texture_lod']
};
const glsl = new Canvas(document.getElementById("glslBg"), options);